export class SupportingDocument {
    DocumentTypeId: number;
    DocumentTypeCode: string;
    DocumentDescription: string;
    DocumentMessage: string;
    Subtext: string;
    FormURL: string;
    DocumentId: number;
    FileKey: string;
    FileName: string;
    Status: string;
    DownloadURL: string;
    FileError: string;
    DocumentNote: string;
    DocumentNoteValidationFailed: boolean = false;
    ExternalLinkUrl?: string;
    ExternalLinkText?: string;
}

export class UploadedSupportingDocument {
    DocumentId: number;
    DocumentTypeId: number;
    FileKey: string;
    FileName: string;
    UserFederatedId: string;
    DocumentNote: string = '';
}


export class SupportingDocumentScanStatus {
    DocumentTypeId: number;
    DocumentId: number;
    Status: string;
}
